import styled from 'styled-components';
import {table} from 'styles/fragments';

export default styled.table`
	${table};
`;
